export const GET_PRISE_RDV = 'getPriseRDV'
export const GET_VISITES_RESIDENCE = 'getVisitesResidence'